import React from 'react'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Card from 'react-bootstrap/Card'
import ListGroup from 'react-bootstrap/ListGroup'
import ListGroupItem from 'react-bootstrap/ListGroupItem'
import Container from 'react-bootstrap/Container'
import Jumbotron from 'react-bootstrap/Jumbotron'

import SolutionCard from './SolutionCard'
import PLSSpeedometer from './PLSSpeedometer'

class Solution extends React.Component {

    render() {
        return (
            <Container fluid>
                <Row><Col><h2 className="text-center">Savings</h2></Col></Row>

                <Row>
                    <Col xs={12} md={6}>
                        <PLSSpeedometer label="Primary energy savings" value={this.props.solution.primary_energy_savings} />
                    </Col>

                    <Col xs={12} md={6}>
                        <PLSSpeedometer label="CO2 Savings" value={this.props.solution.co2_savings} />
                    </Col>
                </Row>

                <Row><Col>
                    <Jumbotron style={{ backgroundColor: "#91dc5b" }}>
                        <h3>Total final energy saving per year: {this.props.solution.total_final_energy_savings_per_year.toFixed(2)} MW/h</h3>
                        <h3>Total primary energy saving per year: {this.props.solution.total_primary_energy_savings_per_year.toFixed(2)} MW/h</h3>
                        <h3>Total CO<sub>2</sub> saving per year: {this.props.solution.total_co2_savings_per_year.toFixed(2)} Tn</h3>
                    </Jumbotron>
                </Col></Row>

                <Row><Col><h2 className="text-center">Constructive elements</h2></Col></Row>
                <Row className="mb-4">
                    <Col>
                        <SolutionCard
                            header="External Walls"
                            type="walls"
                            title={this.props.solution.wall.code}
                            cost={this.props.solution.wall.cost}
                            listElements={[
                                `Typology : ${this.props.solution.wall.typology}`,
                                `Description : ${this.props.solution.wall.description}`,
                                `Insulation material : ${this.props.solution.wall.insulation_material == null ? "N/A" : this.props.solution.wall.insulation_material}`,
                                `Thickness [cm]: ${this.props.solution.wall.thickness == null ? "N/A" : this.props.solution.wall.thickness}`,
                                `Thermal Resistance [m2K/W]: ${this.props.solution.wall.r}`,
                                `Thermal Conductivity [W/mK]: ${this.props.solution.wall.thermal_conductivity == null ? "N/A" : this.props.solution.wall.thermal_conductivity}`,
                                `Other: ${this.props.solution.wall.other == null ? "N/A" : this.props.solution.wall.other}`
                            ]}
                        />
                    </Col>
                    <Col>
                        <SolutionCard
                            header="Glazings"
                            type="windows"
                            title={this.props.solution.window.code}
                            cost={this.props.solution.window.cost}
                            listElements={[
                                `Typology : ${this.props.solution.window.typology}`,
                                `Description : ${this.props.solution.window.description}`,
                                `Insulation material : ${this.props.solution.window.insulation_material == null ? "N/A" : this.props.solution.window.insulation_material}`,
                                `Cavity thickness [cm]: ${this.props.solution.window.cavity_thickness == null ? "N/A" : this.props.solution.window.cavity_thickness}`,
                                `Frame kind: ${this.props.solution.window.frame_kind == null ? "N/A" : this.props.solution.window.frame_kind}`,
                                `U<sub>F</sub>[W/m2K]: ${this.props.solution.window.uf}`,
                                `U<sub>W</sub>[W/m2K]: ${this.props.solution.window.uw}`,
                                `g (Solar factor): ${this.props.solution.window.factor_solar}`
                            ]}
                        />
                    </Col>
                    <Col>
                        <SolutionCard
                            header="Slabs"
                            type="slabs"
                            title={this.props.solution.slab.code}
                            cost={this.props.solution.slab.cost}
                            listElements={[
                                `Typology : ${this.props.solution.slab.typology}`,
                                `Description : ${this.props.solution.slab.description}`,
                                `Insulation material : ${this.props.solution.slab.insulation_material == null ? "N/A" : this.props.solution.slab.insulation_material}`,
                                `Thickness [cm]: ${this.props.solution.slab.thickness == null ? "N/A" : this.props.solution.slab.thickness}`,
                                `Thermal Resistance [m2K/W]: ${this.props.solution.slab.r}`,
                                `Thermal Conductivity [W/mK]: ${this.props.solution.slab.thermal_conductivity == null ? "N/A" : this.props.solution.slab.thermal_conductivity}`,
                            ]}
                        />
                    </Col>
                    <Col>
                        <SolutionCard
                            header="Roof"
                            type="roof"
                            title={this.props.solution.roof.code}
                            cost={this.props.solution.roof.cost}
                            listElements={[
                                `Typology : ${this.props.solution.roof.typology}`,
                                `Description : ${this.props.solution.roof.description}`,
                                `Insulation material : ${this.props.solution.roof.insulation_material == null ? "N/A" : this.props.solution.roof.insulation_material}`,
                                `Thickness [cm]: ${this.props.solution.roof.thickness == null ? "N/A" : this.props.solution.roof.thickness}`,
                                `Thermal Resistance [m2K/W]: ${this.props.solution.roof.r}`
                            ]}
                        />

                    </Col>
                </Row>

                <Row className="mb-4">
                    <Col>
                        <SolutionCard
                            header="Thermal Bridges"
                            type="tb"
                            title={this.props.solution.thermal_bridge.code}
                            cost={this.props.solution.thermal_bridge.cost}
                            listElements={[
                                `Typology : ${this.props.solution.thermal_bridge.typology}`,
                                `Thickness [cm]: ${this.props.solution.thermal_bridge.thickness == null ? "N/A" : this.props.solution.thermal_bridge.thickness}`,
                                `Thermal Resistance [m2K/W]: ${this.props.solution.thermal_bridge.r}`,
                                `Thermal Conductivity [W/mK]: ${this.props.solution.thermal_bridge.thermal_conductivity == null ? "N/A" : this.props.solution.thermal_bridge.thermal_conductivity}`,
                                `Thermal Bridge Reduction [%]: ${this.props.solution.thermal_bridge.thermal_bridge_reduction == null ? "N/A" : this.props.solution.thermal_bridge.thermal_bridge_reduction}`,
                                `Linear Thermal Transmittance Reduction (window) [%]: ${this.props.solution.thermal_bridge.linear_thermal_transmittance_reduction_window == null ? "N/A" : this.props.solution.thermal_bridge.linear_thermal_transmittance_reduction_window}`
                            ]}
                        />

                    </Col>

                    <Col>
                        <SolutionCard
                            header="Ventilation"
                            type="vent"
                            title={this.props.solution.vent_imp.code}
                            cost={this.props.solution.vent_imp.cost}
                            listElements={[
                                `Ventilation: ${this.props.solution.vent_imp.ventilation == null ? "N/A" : this.props.solution.vent_imp.ventilation}`,
                                `Equivalent Air Flow [n air change/h - m3/h]: ${this.props.solution.vent_imp.equivalent_air_flow == null ? "N/A" : this.props.solution.vent_imp.equivalent_air_flow}`
                            ]}
                        />

                    </Col>

                    <Col>
                        <SolutionCard
                            header="Shading elements"
                            type="shadings"
                            title={this.props.solution.shading.code}
                            cost={this.props.solution.shading.cost}
                            listElements={[
                                `Typology : ${this.props.solution.shading.typology}`,
                                `Description : ${this.props.solution.shading.description}`,
                                `Solar Factor : ${this.props.solution.shading.solar_factor == null ? "N/A" : this.props.solution.shading.solar_factor}`
                            ]}
                        />
                    </Col>

                    <Col>
                        <SolutionCard
                            header="Airtightness"
                            type="at"
                            title={this.props.solution.air_tightness.code}
                            cost={this.props.solution.air_tightness.cost}
                            listElements={[
                                `Air Tightness: ${this.props.solution.air_tightness.air_tightness == null ? "N/A" : this.props.solution.air_tightness.air_tightness}`,
                                `n50: ${this.props.solution.air_tightness.n50 == null ? "N/A" : this.props.solution.air_tightness.n50}`
                            ]}
                        />
                    </Col>
                </Row>

                <Row><Col><h2 className="text-center">Systems</h2></Col></Row>

                <Row>
                    <Col>
                        <Card className="text-center">
                            <Card.Header>Heating System</Card.Header>
                            <Card.Body>
                                <Card.Title>{this.props.solution.heating_system.code}</Card.Title>
                                <Card.Text>
                                    <ListGroup className="list-group-flush">
                                        <ListGroupItem>{this.props.solution.heating_system.description}</ListGroupItem>
                                        <ListGroupItem>Details</ListGroupItem>
                                    </ListGroup>
                                </Card.Text>
                            </Card.Body>
                            <Card.Footer className="text-muted">{`Cost: ${this.props.solution.heating_system.cost}€`}</Card.Footer>
                        </Card>
                    </Col>

                    <Col>
                        <Card className="text-center">
                            <Card.Header>Cooling System</Card.Header>
                            <Card.Body>
                                <Card.Title>{this.props.solution.cooling_system.code}</Card.Title>
                                <Card.Text>
                                    <ListGroup className="list-group-flush">
                                        <ListGroupItem>{this.props.solution.cooling_system.description}</ListGroupItem>
                                        <ListGroupItem>Details</ListGroupItem>
                                    </ListGroup>
                                </Card.Text>
                            </Card.Body>
                            <Card.Footer className="text-muted">{`Cost: ${this.props.solution.cooling_system.cost}€`}</Card.Footer>
                        </Card>
                    </Col>

                    <Col>
                        <Card className="text-center">
                            <Card.Header>DHW System</Card.Header>
                            <Card.Body>
                                <Card.Title>{this.props.solution.dhw_system.code}</Card.Title>
                                <Card.Text>
                                    <ListGroup className="list-group-flush">
                                        <ListGroupItem>{this.props.solution.dhw_system.description}</ListGroupItem>
                                        <ListGroupItem>Details</ListGroupItem>
                                    </ListGroup>
                                </Card.Text>
                            </Card.Body>
                            <Card.Footer className="text-muted">{`Cost: ${this.props.solution.dhw_system.cost}€`}</Card.Footer>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col>

                    </Col>
                </Row>

                <Row><Col>
                    <Row><Col><h2 className="text-center">Costs</h2></Col></Row>

                    <Jumbotron style={{ backgroundColor: "#91dc5b" }}>
                        <h3>Total cost: {this.props.solution.total_cost.toFixed(2)} €</h3>
                        <h3>Total cost per dwelling: {this.props.solution.total_cost_per_dwelling.toFixed(2)} €</h3>
                        <h3>Total cost of retrofit + margin: {this.props.solution.compute_total_cost_of_retrofit_plus_margin.toFixed(2)} €</h3>
                        <h3>Payback: {this.props.solution.payback.toFixed(2)} Years</h3>
                    </Jumbotron>
                </Col></Row>

                <Row><Col><h2 className="text-center">Detailed data</h2></Col></Row>
                <Jumbotron style={{ backgroundColor: "#91dc5b" }}>
                    <h3>Primary energy consumption: {this.props.solution.primary_energy_consumption.toFixed(2)} kWh/m<sup>2</sup></h3>
                    <h3>Initial investment:  {this.props.solution.initial_investment.toFixed(2)} €/m<sup>2</sup></h3>
                    <h3>Lifecycle cost: {this.props.solution.life_cycle_cost.toFixed(2)} €/m<sup>2</sup></h3>
                </Jumbotron>

            </Container>);
    }
}

export default Solution;